import React, { useCallback, useState } from "react";
import { CheckboxButton, CheckboxWrapper, ChildrenContainer, Container, Header, Icon, LockedBadge, LockedBadgeTooltip, Square, Title, TitleWrapper } from "./style";

export const ExpandableChart = ({
  // Titulo
  title,
  // Id do gráfico
  id,
  // Conteúdo que será renderizado ao expandir
  children,
   // Prop para checkbox
  checked = false,
  // callback do check
  onCheck,
  // Impede desmarcar o item, para gráfico de exportação obrigatória
  locked = false,
  // Motivo exibido ao passar o mouse sobre o selo de obrigatório
  lockedHint,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => setIsOpen(!isOpen);

  // Controla o estado do checkbox
  // O checkbox travado já é inerte pelo pointer-events do estilo; a guarda
  // aqui evita que uma mudança no CSS reabra a desmarcação sem querer
  const handleCheckQuestion = useCallback(() => {
    if (locked) {
      return;
    }

    if(onCheck) {
      onCheck(id);
    }
  }, [id, locked, onCheck]);

  return (
    <Container>
      <Header>
        <CheckboxWrapper>
          <CheckboxButton isLocked={locked} onClick={handleCheckQuestion}>
            <Square isChecked={checked} />
          </CheckboxButton>

          <TitleWrapper>
            <Title>{title}</Title>

            {locked && (
              <LockedBadge>
                Obrigatório
                <LockedBadgeTooltip>{lockedHint}</LockedBadgeTooltip>
              </LockedBadge>
            )}
          </TitleWrapper>
        </CheckboxWrapper>
        <Icon isOpen={isOpen} onClick={toggleOpen}/>
      </Header>
      {isOpen && <ChildrenContainer>{children}</ChildrenContainer>}
    </Container>
  );
};
